// src/pages/overview.tsx
import React from "react";

import "../styles/pages/overview/overview.css";
import WaitList from "../components/overview/WaitList";

import PlatformOverview from "../components/overview/PlatformOverview";

const OverviewPage: React.FC = () => {
  return (
    <div className="overview-wrapper">
      {/* Call To Action SECTION */}
      <WaitList />
      {/* Platform Overview SECTION */}
      <PlatformOverview />

      {/* HERO SECTION */}
      {/* <Hero /> */}

      {/* Problem Statement SECTION */}
      {/* <ProblemStatement /> */}
    </div>
  );
};

export default OverviewPage;
